import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { axiosGet } from "../../../../common/utils/helper";
import { AxiosResponse } from "axios";
import "./candidateDetails.scss";
import {
  candidateresume,
  getAllCandidateDetails,
} from "../../../../common/utils/api";
import { saveAs } from "file-saver";
import { AiOutlineCloudDownload } from "react-icons/ai";
import Loader from "../../../Loader/loader";
import { UserContext } from "../../../layout/layout";
import { authorizationConstant } from "../../../../common/utils/CommonConstants";
export const CandidateDetails = () => {
  const { user, setUser }: any = useContext(UserContext);

  const candidateId = useParams();
  const [candidateDetail, setCandidateDetail] = useState<any>([]);
  const [candidateTestDetail, setCandidateTestDetail] = useState<any>([]);
  const [candidateEducational, setCandidateEducationalDetail] = useState<any>(
    []
  );
  const [loading, setLoading] = useState(false);
  const PageAccess: string[] =
    user.RoleAccess[location.pathname?.split("/").join("").toLowerCase()];

  useEffect(() => {
    getCandidate(`${getAllCandidateDetails}/${candidateId.candidateId}`);
  }, []);

  async function getCandidate(reqUrl: string) {
    setLoading(true);
    const response = (await axiosGet(reqUrl, {})) as AxiosResponse;
    setCandidateDetail(response?.data?.data.CandidateData);
    setCandidateTestDetail(response?.data?.data.CandidateTestData);
    setCandidateEducationalDetail(
      response?.data?.data.CandidateEducationalData
    );
    setLoading(false);
    // setDegreeName (response?.data?.data?.DegreeName)
  }
  const onDownload = async () => {
    let response: any = await axiosGet(
      `${candidateresume}/${candidateDetail.ProfilePath}`,
      {}
    );
    saveAs(
      "data:application/pdf;base64," + String(response.data.pdfBase64),
      candidateDetail.ProfilePath
    );
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="mb-3 div-managerequest">
      {/* <h4 className="my-3">
        {" "}
        Interview Sheet - {candidateDetail?.FirstName}{" "}
        {candidateDetail?.LastName} {candidateDetail?.Round && "for"}{" "}
        {candidateDetail?.Round} {candidateDetail?.RoundCount}
      </h4> */}
      <div className="requiredskill-blk candidate-details">
        {/* <h3 className="title">Required skills</h3> */}
        <div className="required-card mt-20">
          <div className="required-header">Basic Details</div>
          <div className="required-body">
            <Row>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>First name</label>
                  <span className="detail-view">
                    {candidateDetail?.FirstName}
                  </span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Last name</label>
                  <span className="detail-view">
                    {candidateDetail?.LastName}
                  </span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Date of Birth</label>
                  <span className="detail-view">
                    {candidateDetail?.Birthdate}
                  </span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Gender</label>
                  <span className="detail-view">{candidateDetail?.Gender}</span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Email</label>
                  <span className="detail-view">{candidateDetail?.Email}</span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Contact number</label>
                  <span className="detail-view">
                    {candidateDetail?.MobileNumber}
                  </span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Skype ID</label>
                  <span className="detail-view">
                    {candidateDetail?.SkypeId}
                  </span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Upload photo(.jpg, .png)</label>
                  <span className="detail-view">
                    {/* {candidateDetail?.ImagePath} */}
                    <img
                      src={`data:image/png;base64,${candidateDetail.ImagePath}`}
                      alt="profile-pic"
                      width={40}
                      height={40}
                    />
                  </span>
                </div>
              </Col>

              <Col xs="12" lg="6">
                <div className="form-group">
                  <label>Address1</label>
                  <span className="detail-view">
                    {candidateDetail?.PermanentAddress}
                  </span>
                </div>
              </Col>

              <Col xs="12" lg="6">
                <div className="form-group">
                  <label>Address2</label>
                  <span className="detail-view">
                    {candidateDetail?.PermanentAddress}
                  </span>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className="required-card mt-20">
          <div className="required-header">Education Details</div>
          <div className="required-body">
            {candidateEducational.map((education: any, index: number) => {
              return (
                <Row key={index}>
                  <Col xs="12" md="6" lg="4">
                    <div className="form-group">
                      <label>Education</label>
                      <span className="detail-view">{education?.DegreeId}</span>
                    </div>
                  </Col>
                  <Col xs="12" md="6" lg="4">
                    <div className="form-group">
                      <label>Total marks</label>
                      <span className="detail-view">
                        {education?.TotalMarks}
                      </span>
                    </div>
                  </Col>
                  <Col xs="12" md="6" lg="4">
                    <div className="form-group">
                      <label>Obtained marks</label>
                      <span className="detail-view">
                        {education?.ObtainedMarks}
                      </span>
                    </div>
                  </Col>
                </Row>
              );
            })}
          </div>
        </div>
        <div className="required-card mt-20">
          <div className="required-header">Professional Details</div>
          <div className="required-body">
            <Row>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Current company</label>
                  <span className="detail-view">
                    {candidateDetail?.CurrentCompany}
                  </span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Current location</label>
                  <span className="detail-view">
                    {candidateDetail?.CurrentLocation}
                  </span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                  <div className="form-group">
                    <label>Experience</label>
                    <span className="detail-view">
                      {candidateDetail?.ExperienceYear} years{" "}
                      {candidateDetail?.ExperienceMonth} months
                    </span>
                  </div>
              </Col>
              {PageAccess?.some(
                (access) =>
                  access.toLowerCase() ===
                    authorizationConstant.permissionDisplayCTC.toLowerCase() ||
                  access.toLowerCase() ===
                    authorizationConstant.permissionAll.toLowerCase()
              ) ? (
                <>
                  <Col xs="12" md="6" lg="3">
                    <div className="form-group">
                      <label>Current CTC</label>
                      <span className="detail-view">
                        {candidateDetail?.CurrentCTC}
                      </span>
                    </div>
                  </Col>
                  <Col xs="12" md="6" lg="3">
                    <div className="form-group">
                      <label>Expected CTC</label>
                      <span className="detail-view">
                        {candidateDetail?.ExpectedCTC}
                      </span>
                    </div>
                  </Col>
                </>
              ) : null}

              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Notice period in days</label>
                  <span className="detail-view">
                    {candidateDetail?.NoticePeriod}
                  </span>
                </div>
              </Col>              

              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Preferred job location</label>
                  <span className="detail-view">
                    {candidateDetail?.PreferredLocation}
                  </span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Current designation</label>
                  <span className="detail-view">
                    {candidateDetail?.CurrentDesignation}
                  </span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Expected designation</label>
                  <span className="detail-view">
                    {candidateDetail?.ExpectedDesignation}
                  </span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Technology</label>
                  <span className="detail-view">
                    {candidateDetail?.Technology}
                  </span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Download Resume/CV</label>
                  <span className="detail-view">
                    {candidateDetail?.ProfilePath}
                    <AiOutlineCloudDownload
                      size={20}
                      color={"#ffd700"}
                      onClick={() => {
                        onDownload();
                      }}
                    />
                  </span>
                </div>
              </Col>
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Reference by</label>
                  <span className="detail-view">
                    {candidateDetail?.ReferencedBy ||
                      candidateDetail?.ReferenceName}
                  </span>
                </div>
              </Col>
              {/* <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Employee name</label>
                  <span className="detail-view">
                    {candidateDetail?.FirstName}
                  </span>
                </div>
              </Col> */}
              <Col xs="12" md="6" lg="3">
                <div className="form-group">
                  <label>Candidate Options</label>
                  <span className="detail-view">
                    {candidateDetail &&
                      candidateDetail?.CandidateOption?.join(" , ")}
                  </span>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className="required-card mt-20">
          <div className="required-header">Other Details</div>
          <div className="required-body">
            <Row>
              <Col xs="12" md="12" lg="6">
                <div className="form-group">
                  <label>Requirement mapping</label>
                  <span className="detail-view">
                    {candidateDetail?.Designation}
                    {candidateDetail?.RequirementId}
                  </span>
                </div>
                <div className="form-group">
                  <label>HR comments</label>
                  <span className="detail-view">
                    {candidateDetail?.HRComments}
                  </span>
                </div>
              </Col>
              <Col xs="12" md="12" lg="6">
                <div className="form-group">
                  <label>Assessment Tool</label>
                  <span className="detail-view">
                    {candidateDetail?.AssessmentTool}
                  </span>
                </div>
                <h2 className="assessent-title">Written assessment</h2>
                <div className="assessmentbg">
                  <table>
                    <thead>
                      <tr>
                        <th>Skills evaluated</th>
                        <th>Total score</th>
                        <th>Obtained score</th>
                      </tr>
                    </thead>
                    {candidateTestDetail ? (
                      candidateTestDetail.map((test: any, index: number) => {
                        return (
                          <tbody key={index}>
                            <tr>
                              <td>{test.TestName} Test</td>
                              <td>{test.TotalScore} </td>
                              <td>{test.ObtainScore}</td>
                            </tr>
                          </tbody>
                        );
                      })
                    ) : (
                      <tbody>
                        <tr>
                          <td>No data found</td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateDetails;
